import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Variantes de botão do TEAM portal.
 * Espelha aura-tech-website/src/components/ui/button-variants.ts com adições
 * de domínio: `danger` (deny/revoke actions) + size `xs` (table inline actions).
 *
 * Foco visível é tratado globalmente em global.css (:focus-visible).
 */
export const buttonVariants = cva(
  'group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-sans font-medium transition-[background-color,box-shadow,color,transform] disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-primary text-primary-foreground hover:bg-primary-strong shadow-soft',
        value: 'bg-value text-value-foreground hover:bg-value-strong shadow-soft',
        secondary:
          'border border-border bg-surface text-ink hover:border-ink/25 hover:bg-surface-muted',
        ghost: 'text-ink hover:bg-surface-muted',
        danger: 'bg-error text-white hover:bg-error/90 shadow-soft',
        success: 'bg-success text-white hover:bg-success/90 shadow-soft',
        link: 'px-0 text-signal underline-offset-4 hover:underline',
      },
      size: {
        xs: 'h-7 px-2.5 text-xs',
        sm: 'h-8 px-3 text-[0.8125rem]',
        md: 'h-9 px-4 text-sm',
        lg: 'h-10 px-5 text-sm',
      },
      block: {
        true: 'w-full',
        false: '',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md', block: false },
  },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
